module.exports = __webpack_public_path__ + "static/img/per16.664f769.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per16.jpg
// module id = k14a
// module chunks = 41